import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  noAttachment: {
    id: 'account.order.service.any.modal.error.attachments',
    defaultMessage: 'Please provide one or more attachments.',
  },
  styleSelection: {
    id: 'account.order.artwork.service.modal.error.style.selection',
    defaultMessage: 'Please select at least one Color, Font and Template',
  },
  apiError: {
    id: 'account.order.service.any.modal.error.api',
    defaultMessage: 'Something went wrong. Please try after sometime',
  },
});
